import { useState } from 'react';
import { Modal } from '@/shared/components/ui/Modal';
import { Button } from '@/shared/components/ui/Button';

/** View an existing upload without leaving the order or client profile. */
export function AttachmentPreviewButton({ url, name }: { url: string; name: string }) {
  const [open, setOpen] = useState(false);
  const isImage = /\.(png|jpe?g|webp|gif|bmp)(?:[?#]|$)/i.test(name) || /\.(png|jpe?g|webp|gif|bmp)(?:[?#]|$)/i.test(url);
  const safeUrl = /^(\/[^/]|https?:\/\/)/i.test(url) ? url : '';
  return (
    <span className="inline-flex items-center gap-2" onClick={(event) => event.stopPropagation()}>
      <span className="max-w-48 truncate text-xs" title={name}>{name}</span>
      <Button type="button" size="sm" variant="outline" disabled={!safeUrl} onClick={() => setOpen(true)} aria-label={`View ${name}`}>View</Button>
      <Modal open={open} onClose={() => setOpen(false)} title={name} size="lg" zIndex={1200}
        footer={<><a href={safeUrl} target="_blank" rel="noopener noreferrer" className="text-sm text-blue-700 underline">Open in new tab</a><Button type="button" size="sm" onClick={() => setOpen(false)}>Close</Button></>}>
        {open && (isImage
          ? <img src={safeUrl} alt={name} className="mx-auto max-h-[60vh] max-w-full object-contain" />
          : <iframe src={safeUrl} title={`Preview of ${name}`} className="h-[60vh] w-full rounded border" />)}
      </Modal>
    </span>
  );
}
